import Dexie from 'dexie'

let Db = new Dexie("refapp-main-vueadmin")

Db.version(1).stores({
	configs: 'key,value'
})

export default Db
